import { Box, Button, Flex, Image, Link, Text, useToast } from "@chakra-ui/react";
import React, { memo, useEffect, useState } from "react";
import { useNavigate, Link as RRLink } from "react-router-dom";
import { loginAPI } from "../../Redux/Auth/auth.action";
import FormInput from "../FormInput";
import { useDispatch, useSelector } from "react-redux";

const initLoginState = {
  email: "",
  password: "",
};

const Login = () => {
  const toast = useToast();
  const [formData, setFormData] = useState(initLoginState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const navigate = useNavigate();

  const { isLoading, isAuth, user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    if (!formData.email && !formData.password) {
      toast({
        title: "Please enter email and password",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!formData.email) {
      toast({
        title: "Please enter email",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!formData.password) {
      toast({
        title: "Please enter password",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    dispatch(loginAPI({ ...formData, username: formData.email }));
    // toast({
    //   title: "LoggedIn Succesfully",
    //   status: "success",
    //   duration: "1000",
    //   isClosable: true,
    // });
    // setTimeout(() => {
    //   navigate("/");
    // }, 1000);
  };

  useEffect(() => {
    if (isAuth && user.role !== "guest") {
      toast({
        title: "LoggedIn Succesfully",
        status: "success",
        duration: "1000",
        isClosable: true,
      });
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  return (
    <Box color="white" w="100%" h="100vh" bgGradient="linear(to-r, blue.100, blue.400)" position="fixed">
      <Flex direction="column" align="center" w={["100%", "90%", "60%", "50%"]} m="auto" mt="20px">
        <Image w="65%" src="https://i.ibb.co/P1DCVSv/ripik-trademark-logo.png" />
        <Box w="80%" opacity="0.9">
          <Flex direction="column" bg="white" alignItems="center" p="20px" borderRadius="20px" boxShadow="dark-lg">
            <Text mt="2rem" fontWeight="700" fontSize="22px" align="center" color="black">
              Welcome to Ripik Optimus
            </Text>
            <FormInput name="email" value={formData.email} handleChange={handleChange} type="email" />
            <FormInput
              name={"password"}
              value={formData.password}
              handleChange={handleChange}
              minLength={6}
              type="password"
            />
            <Button
              type="submit"
              w="20%"
              m="auto"
              colorScheme="blue"
              mt="30px"
              mb="10px"
              isLoading={isLoading}
              onClick={handleSubmit}
            >
              Login
            </Button>

            <Link as={RRLink} to="/forgot-password" color="black" my="5">
              Forgot Password? Click here to reset
            </Link>
            <Link as={RRLink} to="/register" color="black">
              Click here to create a new account
            </Link>

            <Text fontSize="15px" mt="20px" opacity="0.6" align="center" color="black">
              Powered by Ripik.AI
            </Text>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default memo(Login);
